import { useMediaQuery } from '@mui/material'
import { Breakpoint, useTheme } from '@mui/system'

export const useIsMobile = (breakPoint: Breakpoint = 'md') => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(breakPoint))
}
